import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Creators as configActions } from '../../../store/ducks/config-section';
import EntregaRetirada from './EntregaRetirada';
import { TIPO_ENTREGA_RETIRADA } from '../../../constants/configuracao-horarios';
import { Header } from '../styles';

import { ConfiguracaoPedidoContainer, ContentContainer } from './styles';

import { Tab, TabText } from '../styles';

const ConfigurarPedidos = ({ section, selectTab }) => {
    return (
        <ConfiguracaoPedidoContainer>
            <ContentContainer>
                <Header>
                    <Tab
                        isSelected={
                            section.idTipoEntregaRetirada ===
                            TIPO_ENTREGA_RETIRADA.RETIRADA
                        }
                        onClick={() => {
                            selectTab({
                                idTipoEntregaRetirada:
                                    TIPO_ENTREGA_RETIRADA.RETIRADA
                            });
                        }}
                    >
                        <TabText
                            isSelected={
                                section.idTipoEntregaRetirada ===
                                TIPO_ENTREGA_RETIRADA.RETIRADA
                            }
                        >
                            Retirada
                        </TabText>
                    </Tab>
                    <Tab
                        isSelected={
                            section.idTipoEntregaRetirada ===
                            TIPO_ENTREGA_RETIRADA.ENTREGA
                        }
                        onClick={() => {
                            selectTab({
                                idTipoEntregaRetirada:
                                    TIPO_ENTREGA_RETIRADA.ENTREGA
                            });
                        }}
                    >
                        <TabText
                            isSelected={
                                section.idTipoEntregaRetirada ===
                                TIPO_ENTREGA_RETIRADA.ENTREGA
                            }
                        >
                            Entrega
                        </TabText>
                    </Tab>
                </Header>
                <EntregaRetirada
                    idTipoEntregaRetirada={section.idTipoEntregaRetirada}
                />
            </ContentContainer>
        </ConfiguracaoPedidoContainer>
    );
};

const mapStateToProps = ({ section }) => {
    return {
        section
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...configActions
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ConfigurarPedidos);
